const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const SwipeHandler = require("../core/view/SwipeHandler");
const SameHeightView = require("./SameHeightView");
const ArrowIcon = require("../core/view/ArrowIcon");
const CircleSequenceButtons = require("./CircleSequenceButtons");

const styles = require("./styles/SwitchView.css");

module.exports = createReactClass({
	displayName: "SwitchView",

	propTypes: {
		views: PT.arrayOf(PT.object).isRequired,
		widthClass: PT.string.isRequired,
		swipeClass: PT.string,

		className: PT.string,

		// Use both or neither
		setSelectedIndex: PT.func,
		selectedIndex: PT.number,

		onSetSelectedIndex: PT.func,

		useTightArrows: PT.bool,
		// Not supported with props setSelectedIndex/selectedIndex pair
		allowWrap: PT.bool,

		useStaticHeight: PT.bool,
		showButtons: PT.bool,
		buttonClass: PT.string,
		hideArrowsOnMobile: PT.bool,
		arrowType: PT.string,
		arrowSize: PT.number,

		preventTitleCollapse: PT.bool,
		buttonTitles: PT.arrayOf(PT.string),
		buttonsOnBottom: PT.bool,
		// Reduces the space between the buttons and the content
		reducedSpacing: PT.bool,
		colorScheme: PT.oneOf([
			"white",
			"cyan",
			"red",
			"blue",
			"grade-2",
			"grade-3",
			"grade-4",
			"grade-5",
		]),
	},

	getDefaultProps: function() {
		return {
			useTightArrows: false,
			allowWrap: true,
			colorScheme: "white",
			reducedSpacing: false,
			arrowType: "standard",
			arrowSize: 1,
		};
	},

	getInitialState: function() {
		return {
			selectedIndex: 0,
			transitionToRight: false,
		};
	},

	beginTransitionTimeout: function() {
		this.isHandlingTransition = true;
		setTimeout(() => (this.isHandlingTransition = false), 400);
	},

	setSelectedIndex: function(index, arrowDelta) {
		if (index === this.getSelectedIndex()) return;
		if (this.isHandlingTransition) return;

		let transitionToRight = index > this.getSelectedIndex();
		if (arrowDelta !== 0) transitionToRight = arrowDelta > 0;

		if (this.props.setSelectedIndex) {
			this.setState({transitionToRight: transitionToRight});
			this.props.setSelectedIndex(index);
		} else {
			this.setState({
				selectedIndex: index,
				transitionToRight: transitionToRight,
			});
		}

		if (this.props.onSetSelectedIndex) {
			this.props.onSetSelectedIndex();
		}

		this.beginTransitionTimeout();
	},

	getSelectedIndex: function(index) {
		if (this.props.setSelectedIndex) {
			return this.props.selectedIndex;
		} else {
			return this.state.selectedIndex;
		}
	},

	onPreviousClick: function() {
		this.switchViewByArrow(-1);
	},

	onNextClick: function() {
		this.switchViewByArrow(1);
	},

	switchViewByArrow: function(delta) {
		if (this.isHandlingTransition) return;

		const n = this.props.views.length;
		this.setSelectedIndex((this.getSelectedIndex() + delta + n) % n, delta);

		this.beginTransitionTimeout();
	},

	render: function() {
		const {colorScheme, views} = this.props;
		const arrowColor = colorScheme;

		const getVisibilityStyle = shouldShow => {
			shouldShow = this.props.allowWrap || shouldShow;
			const buttonStyle = {opacity: shouldShow ? 1 : 0};
			if (!shouldShow) buttonStyle.pointerEvents = "none";
			return buttonStyle;
		};

		const selectedIndex = this.getSelectedIndex();

		const prevStyle = getVisibilityStyle(selectedIndex > 0);
		const nextStyle = getVisibilityStyle(selectedIndex < views.length - 1);

		const arrowType = this.props.useTightArrows ? "tight" : "standard";

		const {showButtons, hideArrowsOnMobile} = this.props;

		let buttonsDiv;
		let spaceDiv;

		if (showButtons) {
			const numSections = this.props.buttonTitles
				? this.props.buttonTitles.length
				: views.length;
			const inactiveIndexes = _.filter(
				_.range(numSections),
				x => x >= views.length
			);

			buttonsDiv = (
				<CircleSequenceButtons
					className={this.props.buttonClass}
					onClick={i => this.setSelectedIndex(i, 0)}
					selectedIndex={this.getSelectedIndex()}
					numSections={numSections}
					titles={this.props.buttonTitles}
					inactiveIndexes={inactiveIndexes}
					colorScheme={this.props.colorScheme}
					preventTitleCollapse={this.props.preventTitleCollapse}
					titlesBelow={this.props.buttonsOnBottom}
				/>
			);
		}

		if (!this.props.buttonsOnBottom) {
			if (showButtons && !this.props.reducedSpacing) {
				spaceDiv = <div className={styles.mainSpace} />;
			}
		}

		let mainClass = this.props.buttonsOnBottom
			? styles.mainBottom
			: styles.main;
		if (hideArrowsOnMobile) mainClass += " " + styles.hideArrow;
		let swipeClass = styles.swipe;
		if (this.props.className) mainClass += " " + this.props.className;
		if (this.props.swipeClass) swipeClass += " " + this.props.swipeClass;

		return (
			<div className={mainClass}>
				{buttonsDiv}
				{spaceDiv}
				<SwipeHandler
					onLeft={this.onNextClick}
					onRight={this.onPreviousClick}
					className={swipeClass}
				>
					<div
						className={styles[arrowType + "Previous"]}
						onClick={this.onPreviousClick}
						style={prevStyle}
					>
						<ArrowIcon
							direction={"left"}
							colorName={arrowColor}
							useScaleHoverEffect={true}
							type={this.props.arrowType}
							size={this.props.arrowSize}
						/>
					</div>
					<SameHeightView
						views={views}
						selectedIndex={selectedIndex}
						sizeClass={this.props.widthClass}
						transitionToRight={this.state.transitionToRight}
						useStaticHeight={this.props.useStaticHeight}
					/>
					<div
						className={styles[arrowType + "Next"]}
						onClick={this.onNextClick}
						style={nextStyle}
					>
						<ArrowIcon
							direction={"right"}
							colorName={arrowColor}
							useScaleHoverEffect={true}
							type={this.props.arrowType}
							size={this.props.arrowSize}
						/>
					</div>
				</SwipeHandler>
			</div>
		);
	},
});
